module.exports = __webpack_public_path__ + "static/scale-model-of-mr.-trash-wheel-in-baltimore-maryland-cf2aa289ebfe1bd68ea8ce1fd5731e31.png";